import type { GameState } from '../state'

const ICONS = { timber: '🪵', fertile: '🌾', stone: '🪨', iron: '⛏' }

/** Owner-only remembered places, using the same projection in either renderer. */
export function drawDiscoveries(ctx: CanvasRenderingContext2D, st: GameState, width: number, height: number): void {
  if (!st.me || st.observer || !st.projectHex) return
  for (const find of st.self?.camp?.discoveries ?? []) {
    const p = st.projectHex(find.q, find.r)
    if (!p.vis || p.x < -50 || p.x > width + 50 || p.y < 15 || p.y > height + 50) continue
    const y = p.y - 34
    ctx.save()
    ctx.fillStyle = 'rgba(16,35,31,.94)'; ctx.strokeStyle = '#8ed5b0'; ctx.lineWidth = 1.5
    ctx.beginPath(); ctx.arc(p.x, y, 12, 0, Math.PI * 2); ctx.fill(); ctx.stroke()
    ctx.beginPath(); ctx.moveTo(p.x - 4, y + 11); ctx.lineTo(p.x, y + 18); ctx.lineTo(p.x + 4, y + 11); ctx.fill()
    ctx.font = '13px system-ui, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'
    ctx.fillStyle = '#e5f5e9'; ctx.fillText(ICONS[find.kind], p.x, y)
    if ((st.hover?.q === find.q && st.hover.r === find.r) || st.tick - find.tick < 45) {
      ctx.font = '600 12px system-ui, sans-serif'
      const w = ctx.measureText(find.name).width + 16
      ctx.fillStyle = 'rgba(16,35,31,.94)'
      ctx.beginPath(); ctx.roundRect(p.x - w / 2, y - 38, w, 21, 5); ctx.fill()
      ctx.fillStyle = '#d5efd9'; ctx.fillText(find.name, p.x, y - 27)
    }
    ctx.restore()
  }
}
